import { Coins } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Small "· N" credit-cost badge shown on generate buttons. Hidden for admin (unlimited).
export function CreditCost({ n }) {
  const { credits } = useAuth();
  if (credits?.unlimited) return null;
  return (
    <span data-testid={`credit-cost-${n}`}
      className="ml-2 inline-flex items-center gap-0.5 rounded-full bg-black/10 px-1.5 py-0.5 text-xs font-semibold">
      <Coins size={11} /> {n}
    </span>
  );
}
